var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lavContainer",staticStyle:{"width":"100%","height":"100&"},style:(_vm.style)})
}
var staticRenderFns = []

export { render, staticRenderFns }